import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
// NOTE: This is a test/demo file. Many API calls need manual updates to use object parameters.
// The DefaultService has been replaced but method signatures need updating.
import {
  BookingDTO,
  OrderApi,
  BookingApi,
  FlightApi,
  FeatureApi,
  PrepaidTicketApi,
  PriceListApi,
  UserApi,
  RoleApi,
  SettingApi,
  ResourceApi,
  PaxApi,
  DemoApi,
  FeatureDTO,
  FlightBookingDTO,
  OrderDTO,
  OrderItemDTO,
  PageBookingDTO,
  PageUserDTO,
  PaymentDTO,
  PrepaidTicketDTO,
  PriceListDTO,
  ResourceStatusDTO,
  RoleDTO,
  SettingDTO,
  TransactionStatusResponseDTO,
  FindCurrentFlightsFlightTypeEnum,
  RoleDTONameEnum,
  ResourceDTOResourceTypeEnum,
  PaymentMethodPaymentMethodIdEnum,
  PaymentDTOTransactionTypeEnum,
  OrderItemDTOOrderItemTypeEnum,
  BookingDTOBookingStatusEnum,
} from '@lkp/parking-sdk';
import {
  ORDER_API,
  FLIGHT_API,
  PAX_API,
  SETTING_API,
  ROLE_API,
  USER_API,
  BOOKING_API,
  PRICE_LIST_API,
  PREPAID_TICKET_API,
  RESOURCE_API,
  DEMO_API,
} from '../../core/providers/api.module';
//import { BookingDTO } from 'parking-sdk/model/bookingDTO';
import {
  Subject,
  first,
  forkJoin,
  map,
  of,
  switchMap,
  takeUntil,
  timer,
} from 'rxjs';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
//import { DefaultService } from 'src/parking-sdk/api/default.service';
//import { OrderDTO } from 'src/parking-sdk/model/orderDTO';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { ExportService } from 'src/app/core/services/export.service';
dayjs.extend(utc);

@Component({
    selector: 'app-relyit',
    templateUrl: './relyit.component.html',
    styleUrls: ['./relyit.component.scss'],
    standalone: false
})
export class RelyitComponent implements OnInit {
  private onDestroy$ = new Subject();
  order: OrderDTO | undefined;
  uti?: string;
  title = 'Rely IT test';
  klarnaSnippet!: string;
  settings: SettingDTO[] | undefined;
  roles: RoleDTO[] | undefined;
  users: PageUserDTO | undefined;
  bookings: PageBookingDTO | undefined;
  priceLists: PriceListDTO[] | undefined;
  priceList: PriceListDTO | undefined;
  currentFlights: FlightBookingDTO[] | undefined;
  prepaidTickets: PrepaidTicketDTO[] | undefined;
  prepaidTicket: PrepaidTicketDTO | undefined;
  smsPreview: string | undefined = '';

  generateBookingForm = new FormGroup({
    fromDate: new FormControl('', {
      validators: [Validators.required],
      updateOn: 'change',
    }),
    toDate: new FormControl('', {
      validators: [Validators.required],
      updateOn: 'change',
    }),
  });
  resourceStatus: ResourceStatusDTO[] | undefined;
  transactionStatus: TransactionStatusResponseDTO | undefined;
  constructor(
    @Inject(ORDER_API) private orderApi: OrderApi,
    @Inject(FLIGHT_API) private flightApi: FlightApi,
    @Inject(PAX_API) private paxApi: PaxApi,
    @Inject(SETTING_API) private settingApi: SettingApi,
    @Inject(ROLE_API) private roleApi: RoleApi,
    @Inject(USER_API) private userApi: UserApi,
    @Inject(BOOKING_API) private bookingApi: BookingApi,
    @Inject(PRICE_LIST_API) private priceListApi: PriceListApi,
    @Inject(PREPAID_TICKET_API) private prepaidTicketApi: PrepaidTicketApi,
    @Inject(RESOURCE_API) private resourceApi: ResourceApi,
    @Inject(DEMO_API) private demoApi: DemoApi,
    private exportService: ExportService,
    private router: Router,
    private authenticateService: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.createOrder();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next(undefined);
    this.onDestroy$.complete();
  }

  createOrder() {
    this.orderApi
      .createOrder({
        affiliateid: 'davidtest1',
        expire: 639712480560000000,
        hash: '60bbe9347559f57dbd4a4408fba6e2570a14bec6a1ea59297a5587aa304b9a51',
      })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((order) => {
        this.order = order;

        // Store order token for private calls
        if (order.token) {
          this.authenticateService.storeOrderToken(order.token);
        }
      });
  }

  /* Remove later */
  generateRandomUppercaseLetters(): string {
    const possibleLetters = 'abcdefghijklmnopqrstuvwxyz';
    let randomLetters = '';

    for (let i = 0; i < 3; i++) {
      const randomIndex = Math.floor(Math.random() * possibleLetters.length);
      randomLetters += possibleLetters.charAt(randomIndex);
    }

    return randomLetters.toUpperCase();
  }

  addBooking() {
    const today = dayjs().utc();
    const passengers = Math.floor(Math.random() * 10 + 1);
    const randomUppercaseLetters = this.generateRandomUppercaseLetters();
    const registrationNumber =
      randomUppercaseLetters +
      Math.floor(Math.random() * (999 - 100 + 1) + 100);
    const departureDate = today;
    //const departureDate = today.add(-7, 'day').add(Math.floor(Math.random() * 3), 'day');

    forkJoin([
      this.flightApi.getFlightsAdmin({
        flightDate: departureDate.toDate(),
        flightType: 'DEPARTURE',
      }),
      this.flightApi.getFlightsAdmin({
        flightDate: departureDate
          .add(Math.ceil(Math.random() * 10), 'day')
          .toDate(),
        flightType: 'ARRIVAL',
      }),
    ])
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(([departures, arrivals]) => {
        const departure =
          departures[Math.floor(Math.random() * departures.length)];
        const arrival = arrivals[Math.floor(Math.random() * arrivals.length)];

        let booking: BookingDTO = {
          name: 'David Starck',
          phone: '+46739224686',
          email: 'david.starck@relyit.se',
          departureDate: departure.suggestedParkingFrom,
          /*  departureDate: new Date("2023-09-10T07:00:00"), */
          /*  arrivalDate: departureDate, */
          arrivalDate: arrival.suggestedParkingTo,
          departureFlight: departure,
          departureFlightNumber: departure.flightNumber,
          arrivalFlight: arrival,
          arrivalFlightNumber: arrival.flightNumber,
          travelHomeFrom: arrival.departureAirport,
          registrationNumber: registrationNumber,
          // registrationNumber: 'KBZ447', // Have prepaidTicket
          resource: {
            resourceId: 3,
            name: 'PARKING_OUTDOOR',
            resourceType: ResourceDTOResourceTypeEnum.LimitedQty,
          },
          qtyPersons: passengers,
          handLuggageOnly: false,
          bookingStatus: BookingDTOBookingStatusEnum.Started,
          // comment: 'David testar att kommentaren kommer fram till Anneli.',
          vehicleType: { vehicleTypeId: 'MEDIUM' },
          engineType: { engineTypeId: 'FUEL' },
        };

        this.orderApi
          .addBookingPrivate({
            orderId: this.order?.orderId || -1,
            bookingDTO: booking,
          })
          .pipe(takeUntil(this.onDestroy$))
          .subscribe((order) => {
            console.log('Order created', order);
            this.order = order;

            /* Testing updateOrderBooking */
            if (order?.orderItems && order?.orderItems[0].booking) {
              this.orderApi
                .updateOrderBookingPrivate({
                  orderId: this.order?.orderId || -1,
                  bookingId: order?.orderItems[0].booking.bookingId || -1,
                  bookingDTO: order?.orderItems[0].booking,
                })
                .pipe(takeUntil(this.onDestroy$))
                .subscribe((order) => {
                  this.order = order;
                  console.log('Order updated by private call', order);

                  if (order && order.orderItems && order.orderItems[0]) {
                    //order.orderItems[0].discount = 100;
                    this.orderApi
                      .updateOrderItemAdmin({
                        orderId: order.orderId || -1,
                        orderItemId: order?.orderItems[0].orderItemId || -1,
                        orderItemDTO: order?.orderItems[0],
                      })
                      .pipe(takeUntil(this.onDestroy$))
                      .subscribe((order) => {
                        this.order = order;
                        console.log('Order updated by admin call', order);
                      });
                  }
                });

              // preview SMS
              // this.orderService.getSmsPreviewAdmin(order?.orderItems[0].booking)
              // .pipe(takeUntil(this.onDestroy$))
              // .subscribe(smsDTO => {
              //   this.smsPreview = smsDTO.body;
              // });
            }
          });
      });
  }

  addFeature() {
    let features: FeatureDTO[] = [
      {
        name: 'Handtvätt',
        featureId: 1,
      },
      {
        name: 'Avspolning',
        featureId: 2,
      },
    ];

    this.orderApi
      .requestFeaturesPrivate({
        orderId: this.order?.orderId || -1,
        featuresRequestDTO: { features: features },
      })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((order) => {
        this.order = order;
      });
  }

  addPrepaidTicket() {
    let prepaidTicket: PrepaidTicketDTO = {
      name: 'Testgenererat årskort',
      maxPark: 1,
      validFrom: dayjs().toDate(),
      validTo: dayjs().add(1, 'year').toDate(),
      cars: [
        {
          registrationNumber: 'ABC123',
        },
      ],
      comment: 'Genererat av Rely IT testsida',
      amount: 3250,
    };
    let orderItem: OrderItemDTO = {
      orderItemType: OrderItemDTOOrderItemTypeEnum.Prepaidticket,
      prepaidTicket: prepaidTicket,
    };

    this.orderApi
      .addOrderItemAdmin({
        orderId: this.order?.orderId || -1,
        orderItemDTO: orderItem,
      })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((order) => {
        this.order = order;
      });
  }

  checkoutOrderKlarna() {
    if (this.order?.orderId) {
      this.orderApi
        .checkoutOrderPrivate({ orderId: this.order?.orderId! })
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((orderResponse) => {
          if (orderResponse.htmlSnippet) {
            this.klarnaSnippet = orderResponse.htmlSnippet;
          }
        });
    }
  }

  checkoutOrderPax() {
    let abortTimerSubject: Subject<void> = new Subject();

    if (this.order?.orderId) {
      let orderId: number = this.order?.orderId;
      let payment: PaymentDTO = {
        paymentMethod: {
          paymentMethodId: PaymentMethodPaymentMethodIdEnum.Pax,
        },
        transactionType: PaymentDTOTransactionTypeEnum.Payment,
        terminalId: 1,
        amount: this.order.amountToPay,
      };
      this.orderApi
        .checkoutOrderAdmin({ orderId, paymentDTO: payment })
        .pipe(
          first(),
          switchMap((transactionResponse) => {
            if (transactionResponse.uti) {
              let uti: string = transactionResponse.uti;
              this.uti = uti;
              return timer(0, 1000).pipe(
                takeUntil(abortTimerSubject),
                switchMap(() =>
                  this.orderApi.getCheckoutStatusAdmin({ orderId, uti }).pipe(
                    map((transactionStatus) => {
                      console.log(transactionStatus.displayData);
                      if (transactionStatus.transApproved) {
                        abortTimerSubject.next();
                        abortTimerSubject.complete();
                      }
                      if (transactionStatus.transCancelled) {
                        abortTimerSubject.next();
                        abortTimerSubject.complete();
                      }
                      return transactionStatus;
                    })
                  )
                )
              );
            } else {
              // Return error?
              return of();
            }
          })
        )
        .subscribe((transactionStatus) => {
          this.transactionStatus = transactionStatus;
        });
    }
  }

  abortPaxTransaction() {
    if (this.order?.orderId && this.uti) {
      this.orderApi
        .cancelRapydTransactionAdmin({
          orderId: this.order.orderId,
          uti: this.uti,
        })
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(() => {
          console.log('Transaction aborted');
        });
    }
  }

  checkoutOrderCash() {
    let abortTimerSubject: Subject<void> = new Subject();

    if (this.order?.orderId) {
      let orderId: number = this.order?.orderId;
      let payment: PaymentDTO = {
        paymentMethod: {
          paymentMethodId: PaymentMethodPaymentMethodIdEnum.Cash,
        },
        transactionType: PaymentDTOTransactionTypeEnum.Payment,
        amount: this.order.amountToPay,
      };
      this.orderApi
        .checkoutOrderAdmin({ orderId, paymentDTO: payment })
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((orderResponse) => {
          console.log(orderResponse);
        });
    }
  }

  checkoutOrderNoPay() {
    if (this.order?.orderId) {
      this.orderApi
        .checkoutOrderNoPayPrivate({ orderId: this.order?.orderId! })
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((order) => {
          // Redirect to confirm page
          this.router.navigateByUrl(`/klarna-confirm?id=${order.orderId}`);
        });
    }
  }

  getSettings() {
    this.settingApi
      .getSettings()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((settings) => {
        this.settings = settings;
      });
  }

  getRoles() {
    this.roleApi
      .getRoles()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((roles) => {
        this.roles = roles;
      });
  }

  getUsers() {
    this.userApi
      .getUsers({})
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((users) => {
        this.users = users;
      });
  }
  createUser() {
    this.userApi
      .createUser({
        userDTO: {
          username: 'new@relyit.se',
          roles: [
            { id: 1, name: RoleDTONameEnum.User },
            { id: 2, name: RoleDTONameEnum.Admin },
          ],
        },
      })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((user) => {
        console.log('user created', user);

        // Set password on user
        if (user.id) {
          this.userApi
            .setPassword({
              userId: user.id,
              userPassword: { userId: user.id, password: '123456' },
            })
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(() => {
              console.log('password updated');
              this.getUsers();
            });
        }
      });
  }
  deleteUser() {
    if (this.users && this.users.content && this.users.content?.length > 0) {
      let userToDelete = this.users.content.filter(
        (user) => user.username === 'new@relyit.se'
      );
      if (userToDelete.length > 0 && userToDelete[0].id) {
        this.userApi
          .deleteUser({ userId: userToDelete[0].id })
          .pipe(takeUntil(this.onDestroy$))
          .subscribe((user) => {
            console.log('user deleted', userToDelete[0]);
            this.getUsers();
          });
      }
    }
  }

  getBookings() {
    this.bookingApi
      .getBookingsAdmin({
        page: 0,
        size: 5,
        sort: 'createdDate,desc',
        searchTerm: '%',
      })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((bookings) => {
        this.bookings = bookings;
      });
  }

  getPriceLists() {
    this.priceListApi
      .getPriceListsAdmin()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((priceLists) => {
        this.priceLists = priceLists;
      });
  }

  getPriceList(priceListId: number | undefined) {
    if (priceListId) {
      this.priceListApi
        .getPriceListAdmin({ priceListId })
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((priceList) => {
          this.priceList = priceList;
        });
    }
  }

  deletePriceList(priceListId: number | undefined) {
    if (priceListId && priceListId > 3) {
      this.priceListApi
        .deletePriceListAdmin({ priceListId })
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(() => {
          this.priceList = undefined;
          this.getPriceLists();
        });
    }
  }

  findCurrentFlights() {
    this.flightApi
      .findCurrentFlights({ flightType: FindCurrentFlightsFlightTypeEnum.All })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((currentFlights) => {
        this.currentFlights = currentFlights;
      });
  }

  generateBookings() {
    if (
      this.generateBookingForm.value.fromDate &&
      this.generateBookingForm.value.toDate
    ) {
      this.demoApi
        .demoGenerateOrders({
          fromDate: dayjs(this.generateBookingForm.value.fromDate!).toDate(),
          toDate: dayjs(this.generateBookingForm.value.toDate!).toDate(),
        })
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(() => {
          console.log(
            'Bookings generated for',
            this.generateBookingForm.value.fromDate,
            this.generateBookingForm.value.toDate
          );
        });
    }
  }

  getPrepaidTickets() {
    this.prepaidTicketApi
      .getPrepaidTicketsAdmin({ page: 0, size: 1000 })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((prepaidTickets) => {
        this.prepaidTickets = prepaidTickets.content;
      });
  }

  getPrepaidTicket(prepaidTicketId: number | undefined) {
    if (prepaidTicketId) {
      this.prepaidTicketApi
        .getPrepaidTicketAdmin({ prepaidTicketId })
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((prepaidTicket) => {
          this.prepaidTicket = prepaidTicket;
        });
    }
  }

  createPrepaidTicket() {
    let prepaidTicket: PrepaidTicketDTO = {
      name: 'TestBiljett',
      validFrom: new Date('2023-12-31T23:00:00'),
      validTo: new Date('2024-12-31T23:00:00'),
      maxPark: 1,
      cars: [
        {
          registrationNumber: 'ABC123',
        },
        {
          registrationNumber: 'ABC321',
        },
        {
          registrationNumber: 'CBA123',
        },
        {
          registrationNumber: 'CBA321',
        },
      ],
      comment: 'Rely IT testar',
      resource: {
        label: 'Utomhus',
        name: 'PARKING_OUTDOOR',
        resourceId: 3,
        resourceType: ResourceDTOResourceTypeEnum.LimitedQty,
      },
    };

    this.prepaidTicketApi
      .createPrepaidTicketAdmin({ prepaidTicketDTO: prepaidTicket })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((prepaidTicket) => {
        this.getPrepaidTickets();
      });
  }

  deletePrepaidTicket(prepaidTicketId: number | undefined) {
    if (prepaidTicketId) {
      this.prepaidTicketApi
        .deletePrepaidTicketAdmin({ prepaidTicketId })
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(() => {
          this.prepaidTicket = undefined;
          this.getPrepaidTickets();
        });
    }
  }

  getFlights() {
    const date = new Date();

    this.flightApi
      .getFlightsAdmin({
        flightDate: date,
        flightType: 'ARRIVAL',
      })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((flight) => {
        console.log(flight);
      });
  }

  getAvailableResources() {
    const date = dayjs().add(7, 'day');
    let booking: BookingDTO = {
      departureDate: date.toDate(),
      arrivalDate: date.add(5, 'day').toDate(),
    };

    this.resourceApi
      .getAvailableResources({ bookingDTO: booking })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((resourceStatus) => {
        this.resourceStatus = resourceStatus;
      });
  }

  downloadReportBookings() {
    const date = dayjs();
    this.exportService.getReportBookings(
      date.toDate(),
      date.add(7, 'day').toDate()
    );
  }
}
